import { useEffect, useRef } from 'react';
import authTokenUtil from '../../account/authTokenUtil';
import useScript from '../../utils/network/useScript';
import useAppSelector from '../redux/useAppSelector';

const GoogleAnalytics = () => {
  const id = window.__slab.GOOGLE_ANALYTICS_MEASUREMENT_ID;
  const hasInitializedRef = useRef(false);
  const userId = useAppSelector((state) => state.session.user.id);

  useEffect(() => {
    const hasUserSessionSettled = !!userId || !authTokenUtil.get();

    if (hasInitializedRef.current || !hasUserSessionSettled) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // Google Analytics doesn't work with rest parameters
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer?.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', id, userId ? { user_id: userId } : {});

    hasInitializedRef.current = true;
  }, [id, userId]);

  useScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);

  return null;
};

export default GoogleAnalytics;
